export default __webpack_public_path__ + "static/media/multiply~PkYNnPbh.0e8264c4.svg";